import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../services/api";

const useStyles = makeStyles((theme) => ({
  input: { marginBottom: theme.spacing(2) },
  tokenBox: {
    backgroundColor: "#f3f4f6",
    padding: theme.spacing(2),
    borderRadius: 8,
    marginTop: theme.spacing(2),
    fontFamily: "monospace",
    textAlign: "center",
    wordBreak: "break-all",
  },
  successBox: {
    backgroundColor: "#dcfce7",
    border: "1px solid #22c55e",
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: "center",
  },
}));

export default function CreateConnectionModal({ open, onClose }) {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [typebot, setTypebot] = useState(""); // ✅ adiciona o state do ID do fluxo
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!name.trim()) {
      toast.warning("Informe um nome para a conexão.");
      return;
    }

    setLoading(true);

    try {
      // envia também o ID do fluxo
      const { data } = await api.post("/whatsapp/create-account", {
        name,
        typebot,
      });

      if (data.success && data.data?.token) {
        // 🔐 Salva token e dados localmente
        localStorage.setItem("whatsToken", data.data.token);
        localStorage.setItem("whatsName", name);
        localStorage.setItem("whatsTypebot", typebot || ""); // ✅ salva o fluxo

        toast.success("Conexão criada com sucesso!");
        onClose(); // ✅ fecha automaticamente o modal
      } else {
        toast.error("Erro ao criar conexão.");
      }
    } catch (error) {
      console.error("❌ Erro ao criar conexão:", error);
      toast.error("Erro ao criar conexão.");
    } finally {
      setLoading(false);
      setName("");
      setTypebot("");
    }
  };

  const handleClose = () => {
    setName("");
    setTypebot("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>🆕 Criar Nova Conexão</DialogTitle>
      <DialogContent>
        <TextField
          label="Nome da Conexão"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={classes.input}
          disabled={loading}
        />

        <TextField
          label="ID do Fluxo (Typebot)"
          fullWidth
          variant="outlined"
          value={typebot}
          onChange={(e) => setTypebot(e.target.value)}
          className={classes.input}
          disabled={loading}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="default" disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleCreate}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={22} /> : "Criar Conexão"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
